import { ISpecificationGroup } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import { useState } from "react";
import ProdDetails from "./ProdDetails";
import ProdSpec from "./ProdSpec";
import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import { useTranslation } from "@/hooks/localization/useTranslations";
import ProductDetailsReview from "../ProductDetailsReview";
import { Ratings } from "@/api/AppApi/services/home/interfaces/IProduct";

interface Props {
  html: any;
  spec: ISpecificationGroup[];
  showRate: boolean;
  rate: number;
  ratings: Ratings;
  productId: number;
  canReview: boolean;
}
const PcTabs: React.FC<Props> = ({
  html,
  spec,
  showRate,
  rate,
  ratings,
  productId,
  canReview,
}) => {
  const t = useTranslation();
  const tabs = [];
  if (!!html) tabs.push({ label: t.product_details, selector: "html" });
  if (!!spec && spec?.length > 0)
    tabs.push({ label: t.specifications, selector: "spec" });
  if (showRate) tabs.push({ label: t.item_review, selector: "rate" });
  const [btnSelector, setBtnSelector] = useState(tabs[0].selector);
  return (
    <div>
      <div className="tabs-container">
        {tabs.map((tab) => (
          <CustomButton
            style={
              tab.selector !== btnSelector ? { background: "transparent" } : {}
            }
            key={tab.selector}
            type={
              tab.selector === btnSelector ? BtnTypes.primary : BtnTypes.neutral
            }
            size={BtnSizes.medium}
            radius={BtnRadius.large}
            noBorder
            onClick={() => setBtnSelector(tab.selector)}
          >
            {tab.label}
          </CustomButton>
        ))}
      </div>
      {btnSelector === "html" ? (
        <ProdDetails html={html} />
      ) : btnSelector === "spec" ? (
        <ProdSpec spec={spec} />
      ) : (
        <>
          {showRate && (
            <ProductDetailsReview
              rate={rate}
              ratings={ratings}
              productId={productId}
              canReview={canReview}
              mobile={false}
            />
          )}
        </>
      )}
    </div>
  );
};

export default PcTabs;
